import { useQuery } from '@tanstack/react-query'

import type { PoliticalCampaign } from '@/types/models'
import { advertiserTopicsByElection, type TopicsByElection } from '@/services/political/politicalTopics'

const NO_CAMPAIGNS: PoliticalCampaign[] = []

/**
 * The topics an advertiser may book against, per election. Used by political
 * line items to offer an election and then its topics, and to show how many
 * topics each election has. `linkedElectionIds` lists the only elections the
 * advertiser can book, from its linked campaigns or else its political budgets.
 */
export function useElectionTopics(advertiserId: string | undefined, enabled = true) {
  const query = useQuery({
    queryKey: ['election-topics', advertiserId],
    queryFn: () => advertiserTopicsByElection(advertiserId!),
    enabled: !!advertiserId && enabled,
    staleTime: 5 * 60 * 1000,
  })

  const topicsByElection: TopicsByElection = query.data?.topicsByElection ?? {}
  const campaigns: PoliticalCampaign[] = query.data?.campaigns ?? NO_CAMPAIGNS
  return {
    topicsByElection,
    linkedElectionIds: query.data?.linkedElectionIds,
    campaigns,
    isLoading: query.isLoading,
  }
}
